module.exports = __webpack_public_path__ + "img/mailing.c7a5ef23.png";